import React, { useEffect, useState } from "react";
import "bootstrap-select";
import { useSelector } from "react-redux";
import { useParams, useNavigate, Link } from "react-router-dom";
import RetailPartnerService from "service/RetailPartnerService/RetailPartnerService";
import LoadingSpinner from "component/LoadingSpinner";
import { RetailPartnerCreateReq } from "domain/payload/request/retailPartner/RetailPartnerCreateReq";
import { RetailPartnerUpdateReq } from "domain/payload/request/retailPartner/RetailPartnerUpdateReq";

const RetailPartnerForm: React.FC = () => {
  const { id } = useParams();
  const { profile } = useSelector((state: any) => state.auth);
  const navigate = useNavigate();

  const retailPartnerService = RetailPartnerService();

  const [storeName, setStoreName] = useState("");
  const [ownerName, setOwnerName] = useState("");
  const [ownerEmail, setownerEmail] = useState("");
  const [ownerPhone, setownerPhone] = useState("");
  const [landmark, setLandmark] = useState("");
  const [address, setAddress] = useState("");
  const [latitude, setLatitude] = useState("");
  const [longitude, setLongitude] = useState("");

  const [isLoadingDetail, setIsLoadingDetail] = useState(false);
  const [isLoadingSave, setIsLoadingSave] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsLoadingSave(true);

    try {
      if (id === "0") {
        await createRetailPartner();
        alert(`Retail Partner ${storeName} successfully created!`);
      } else {
        await updateRetailPartner();
        alert(`Retail Partner ${storeName} successfully updated!`);
      }
      navigate("/retail-partner");
    } catch (err: any) {
      console.error(err);
      const errorMessage = err.response?.data?.message || err.message || 'Terjadi kesalahan saat menyimpan data';
      alert(`Error: ${errorMessage}`);
    } finally {
      setIsLoadingSave(false);
    }
  };

  const fetchDetail = async () => {
    const token = profile?.data.token;
    if (!token) {
      window.alert('Token tidak ditemukan. Silakan login kembali.');
      return;
    }

    setIsLoadingDetail(true);
    try {
      const res = await retailPartnerService.getDetail(token, id ?? "0");
      setStoreName(res.data?.storeName ?? "");
      setOwnerName(res.data?.ownerName ?? "");
      setownerEmail(res.data?.ownerEmail ?? "");
      setownerPhone(res.data?.ownerPhone ?? "");
      setAddress(res.data?.address ?? "");
      setLandmark(res.data?.landmark ?? "");
      setLatitude(res.data?.latitude?.toString() ?? "");
      setLongitude(res.data?.longitude?.toString() ?? "");
    } catch (err: any) {
      console.error(err);
      const errorMessage = err.response?.data?.message || err.message || 'Terjadi kesalahan saat mengambil detail retail partner';
      window.alert(`Error: ${errorMessage}`);
    } finally {
      setIsLoadingDetail(false);
    }
  };

  const createRetailPartner = async () => {
    const token = profile?.data.token;
    if (!token) {
      window.alert('Token tidak ditemukan. Silakan login kembali.');
      return;
    }

    if (latitude && isNaN(parseFloat(latitude))) {
      throw new Error("Latitude harus berupa angka yang valid");
    }
    if (longitude && isNaN(parseFloat(longitude))) {
      throw new Error("Longitude harus berupa angka yang valid");
    }

    const request: RetailPartnerCreateReq = {
      storeName,
      ownerName,
      ownerPhone,
      ownerEmail,
      landmark,
      address,
      latitude: latitude ? parseFloat(latitude) : 0,
      longitude: longitude ? parseFloat(longitude) : 0,
    };

    await retailPartnerService.insert(token, request);
  };

  const updateRetailPartner = async () => {
    const token = profile?.data.token;
    if (!token) {
      window.alert('Token tidak ditemukan. Silakan login kembali.');
      return;
    }

    if (latitude && isNaN(parseFloat(latitude))) {
      throw new Error("Latitude harus berupa angka yang valid");
    }
    if (longitude && isNaN(parseFloat(longitude))) {
      throw new Error("Longitude harus berupa angka yang valid");
    }

    const request: any = { id };

    if (storeName) request.storeName = storeName;
    if (ownerName) request.ownerName = ownerName;
    if (ownerPhone) request.ownerPhone = ownerPhone;
    if (ownerEmail) request.ownerEmail = ownerEmail;
    if (address) request.address = address;
    if (landmark) request.landmark = landmark;
    if (latitude) request.latitude = parseFloat(latitude);
    if (longitude) request.longitude = parseFloat(longitude);

    await retailPartnerService.update(token, request);
  };

  useEffect(() => {
    if (id !== "0") {
      fetchDetail();
    }
  }, []);

  return (
    <div className="pt-1 h-100" style={{ background: "#f2f4f8" }}>
      <div className="m-4">
        <h4 className="mb-4">
          {id === "0" ? "Add Retail Partner" : "Edit Retail Partner"}
        </h4>
        <div className="p-4" style={{ background: "white" }}>
          {isLoadingDetail ? (
            <LoadingSpinner />
          ) : (
            <form onSubmit={handleSubmit}>
              <div className="row">
                <div className="col-sm-6">
                  <div>
                    <h5 className="mb-4">Store Information</h5>
                    <div className="mb-3">
                      <label
                        htmlFor="storeName"
                        className="form-label fw-semibold"
                      >
                        Store Name
                      </label>
                      <input
                        type="text"
                        id="storeName"
                        className="form-control form-control-compact"
                        value={storeName}
                        placeholder="Store Name"
                        onChange={(e) => setStoreName(e.target.value)}
                      />
                    </div>
                    <div className="mb-3">
                      <label
                        htmlFor="ownerName"
                        className="form-label fw-semibold"
                      >
                        Owner Name
                      </label>
                      <input
                        type="text"
                        id="ownerName"
                        className="form-control form-control-compact"
                        value={ownerName}
                        placeholder="Owner Name"
                        onChange={(e) => setOwnerName(e.target.value)}
                        required
                      />
                    </div>
                    <div className="mb-3">
                      <label
                        htmlFor="ownerPhone"
                        className="form-label fw-semibold"
                      >
                        Owner Phone
                      </label>
                      <input
                        type="number"
                        id="ownerPhone"
                        className="form-control form-control-compact"
                        value={ownerPhone}
                        placeholder="Owner Phone"
                        onChange={(e) => setownerPhone(e.target.value)}
                        required
                      />
                    </div>
                  </div>
                </div>

                <div className="col-sm-6">
                  <div>
                    <h5 className="mb-4">Location</h5>
                    <div className="mb-3">
                      <label
                        htmlFor="address"
                        className="form-label fw-semibold"
                      >
                        Address
                      </label>
                      <input
                        type="text"
                        id="address"
                        className="form-control form-control-compact"
                        value={address}
                        placeholder="Address"
                        onChange={(e) => setAddress(e.target.value)}
                      />
                    </div>
                    <div className="mb-3">
                      <label
                        htmlFor="landmark"
                        className="form-label fw-semibold"
                      >
                        Landmark
                      </label>
                      <input
                        type="text"
                        id="landmark"
                        className="form-control form-control-compact"
                        value={landmark}
                        placeholder="landmark"
                        onChange={(e) => setLandmark(e.target.value)}
                      />
                    </div>
                    <div className="mb-3">
                      <label
                        htmlFor="latitude"
                        className="form-label fw-semibold"
                      >
                        Latitude
                      </label>
                      <input
                        type="text"
                        id="latitude"
                        className="form-control form-control-compact"
                        value={latitude}
                        placeholder="Latitude"
                        onChange={(e) => setLatitude(e.target.value)}
                      />
                    </div>
                    <div className="mb-3">
                      <label
                        htmlFor="longitude"
                        className="form-label fw-semibold"
                      >
                        Longitude
                      </label>
                      <input
                        type="text"
                        id="longitude"
                        className="form-control form-control-compact"
                        value={longitude}
                        placeholder="Longitude"
                        onChange={(e) => setLongitude(e.target.value)}
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div className="w-100 d-flex justify-content-end">
                <Link to="/retail-partner">
                  <button className="btn btn-outline-primary">Cancel</button>
                </Link>
                <button
                  type="submit"
                  className="btn btn-primary d-flex justify-content-center align-items-center ms-2"
                  disabled={isLoadingSave}
                >
                  {isLoadingSave && (
                    <>
                      <LoadingSpinner reverse={true} />
                      <p className="ms-2"></p>
                    </>
                  )}
                  Save
                </button>
              </div>
            </form>
          )}
        </div>
      </div>
    </div>
  );
};

export default RetailPartnerForm;
